import React, { useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"

//components
import Table from "../../../Components/TableTemplate/DataTable"
import Navbar from "../../../Components/Navbar/Navbar"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import AddModal from "../../../Components/Modals/AddModal"
import EditModal from "../../../Components/Modals/EditModal"
import ViewModal from "../../../Components/Modals/ViewModal"
import InputError from "../../../Components/InputError/InputError"
import Footer from "../../../Components/Footer/Footer"
import { Upload } from "antd"
import upload from "../../../Assets/Images/upload.png"
import trash from "../../../Assets/Images/trash.png"
import FileExceedModal from "../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import Modal from "antd/es/modal/Modal"

//css
import "./../Manage.css"
import "../../../Components/Navbar/Navbar.css"
import {
  isAdmin,
  numberFormat,
  refreshPage,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import { validateCustomer } from "../../../Helpers/Validation/Manage/ForwardersValidation"
import toast from "react-hot-toast"
import {
  createCustomer,
  deleteCustomer,
  getCustomer,
  updateCustomer,
} from "../../../Helpers/apiCalls/Manage/CustomersApi"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"

const { Dragger } = Upload

export default function Customers() {
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [selectDropdown, setSelectDropdown] = useState("Select")
  const [filterConfig, setFilterConfig] = useState({
    page: 1,
  })
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewType, setPreviewType] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  // to remove uploaded file in dragger
  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  // to set uploaded file
  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  // to remove previously saved attachment
  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => {
    setSelectDropdown("Select")
    setShowDeleteModal(false)
  }
  // VIEW
  const [showViewModal, setShowViewModal] = useState(false)
  const handleShowViewModal = () => setShowViewModal(true)
  const handleCloseViewForwarderModal = () => {
    setSelectDropdown("Select")
    setShowViewModal(false)
  }

  // EDIT
  const [showEditModal, setShowEditModal] = useState(false)
  const handleShowEditModal = () => setShowEditModal(true)
  const handleCloseEditForwarderModal = () => {
    setSelectDropdown("Select")
    setShowEditModal(false)
  }

  // ADD
  const [showAddModal, setShowAddModal] = useState(false)
  const handleShowAddModal = () => setShowAddModal(true)
  const handleCloseAddForwarderModal = () => {
    setSelectDropdown("Select")
    setShowAddModal(false)
  }
  //API
  const [tableData, setTableData] = useState([])
  const [selectedRow, setSelectedRow] = useState({})
  const [addDetails, setAddDetails] = useState({
    name: "",
    address: " ",
    phone_no: "",
  })
  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    trade_name: false,
    credit_limit: false,
  })

  //ONCHANGE
  //ADD or CREATE FORWARDER
  const handleAddChange = (e) => {
    const { name, value } = e.target
    console.log("Name:", name)
    console.log("Value:", value)
    if (name === "vat_type") {
      var percentage =
        value === "vat" || value === "VAT"
          ? addDetails.withholding_percentage
          : ""
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: value,
        withholding_percentage: percentage,
      }))
    } else {
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }
  //onEdit
  function handleOnEdit() {
    handleCloseViewForwarderModal()
    handleShowEditModal()
  }

  //EDIT OR UPDATE FORWARDER
  const handleEditChange = (e) => {
    const { name, value } = e.target
    if (name === "vat_type") {
      var percentage =
        value === "vat" || value === "VAT"
          ? addDetails.withholding_percentage
          : ""
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: value,
        withholding_percentage: percentage,
      }))
    } else {
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  //DROPDOWN
  function handleSelectChange(e, row) {
    // fetchForwarder(row.id);
    setSelectedRow(row)
    setPrevAttachments(row.attachments)
    row.withholding_percentage = row.withholding_percentage
      ? parseInt(row.withholding_percentage).toString()
      : ""
    setAddDetails(row)
    if (e.target.value === "delete") {
      setSelectDropdown("delete")
      handleShowDeleteModal()
    } else if (e.target.value === "edit") {
      setSelectDropdown("edit")
      handleShowEditModal()
    } else if (e.target.value === "view") {
      setSelectDropdown("view")
      handleShowViewModal()
    } else {
      setSelectDropdown("Select")
      handleShowDeleteModal()
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        value={selectDropdown}
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  //API CALL
  async function fetchCustomers() {
    setTotalItems(0)
    setShowLoader(true)
    const response = await getCustomer(filterConfig)
    if (response.data) {
      var sortedData = response.data.data.sort((a, b) =>
        a.trade_name > b.trade_name ? 1 : b.trade_name > a.trade_name ? -1 : 0
      )
      setTableData(sortedData)
      setTotalItems(response.data.size)
    } else {
      setTableData([])
    }
    setShowLoader(false)
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value, page: 1 }
    })
  }

  async function handleSaveCustomer() {
    setIsClicked(true)
    if (validateCustomer(addDetails, setIsError)) {
      addDetails.attachments = fileList
      const response = await createCustomer(addDetails)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        handleCloseAddForwarderModal()
        // refreshPage();
        setAddDetails({})
        setFileList([])
        setPrevAttachments([])
        setTimeout(() => {
          fetchCustomers()
        }, 1000)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setTimeout(() => {
          // refreshPage()
        }, 1000)
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
    setIsClicked(false)
  }

  async function handleEditCustomer() {
    setIsClicked(true)
    if (validateCustomer(addDetails, setIsError)) {
      addDetails.attachments = fileList
      addDetails.prev_files = prevAttachments
      const response = await updateCustomer(addDetails)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        handleCloseEditForwarderModal()
        setAddDetails({})
        setFileList([])
        setPrevAttachments([])
        // refreshPage();
        setTimeout(() => {
          fetchCustomers()
        }, 1000)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
    setIsClicked(false)
  }

  async function handleDeleteCustomer() {
    setIsClicked(true)
    const response = await deleteCustomer(selectedRow.id)
    if (response.data) {
      toast.success("Customer is deleted", {
        style: toastStyle(),
      })
      handleCloseDeleteModal()
      refreshPage()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  useEffect(() => {
    fetchCustomers()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              CUSTOMERS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              className="search-bar"
              defaultValue=""
              placeholder="Search name..."
              name="trade_name"
              // onChange={(e) => handleOnSearch(e)}
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
            ></input>
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={handleShowAddModal}>
                Add
              </button>
            </div>
          </Col>
        </Row>
        <div className="tab-content">
          {/* TABLE */}
          <TableWithDynamicPagination
            tableHeaders={[
              "TRADE NAME",
              "TRADE ADDRESS",
              "PHONE NO",
              "CREDIT LIMIT",
              "VAT TYPE",
              "ACTIONS",
            ]}
            headerSelector={[
              "trade_name",
              "trade_address",
              "phone_no",
              "credit_limit",
              "vat_type",
            ]}
            tableData={tableData}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
            // used in dynamic pagination
            totalItems={totalItems}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="customer"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteCustomer}
        isClicked={isClicked}
      />
      <AddModal
        title="CUSTOMER"
        size="lg"
        type="customer"
        show={showAddModal}
        onHide={handleCloseAddForwarderModal}
        onSave={handleSaveCustomer}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col xs={12} lg={6}>
              TRADE NAME
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="trade_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_name}
                message={"Name is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              BIR NAME
              {/* <span className="required-icon">*</span> */}
              <Form.Control
                type="text"
                name="bir_name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col>
              TRADE ADDRESS
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="trade_address"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_address}
                message={"Trade Address is required"}
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col>
              BIR REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              TIN
              <Form.Control
                type="text"
                name="tin"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              TERM (days)
              <span className="required-icon">*</span>
              <Form.Control
                type="number"
                name="terms"
                className="nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.terms}
                message={"Terms is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              PHONE NO.
              <Form.Control
                type="text"
                name="phone_no"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              EMAIL
              <Form.Control
                type="text"
                name="email"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              CONTACT PERSON
              <Form.Control
                type="text"
                name="contact_person"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              CREDIT LIMIT
              <span className="required-icon">*</span>
              <Form.Control
                type="number"
                name="credit_limit"
                className="nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.credit_limit}
                message={"Credit limit is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              PAYEE
              <Form.Control
                type="text"
                name="payee"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <div className="mb-3" />
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              VAT Type
              <span className="required-icon">*</span>
              <Row className="mb-3">
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="VAT"
                      name="vat_type"
                      value="vat"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="NVAT"
                      name="vat_type"
                      value="nvat"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <InputError
                isValid={isError.vat_type}
                message={"VAT Type is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              BIR 2307
              <Row className="mb-3">
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDetails.withholding_percentage === "1" &&
                        addDetails.vat_type !== "nvat"
                      }
                      disabled={addDetails.vat_type === "nvat" ? true : false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      onChange={(e) => handleAddChange(e)}
                      checked={
                        addDetails.withholding_percentage === "2" &&
                        addDetails.vat_type !== "nvat"
                      }
                      disabled={addDetails.vat_type === "nvat" ? true : false}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="CUSTOMER"
        size="lg"
        type="customer"
        show={showEditModal}
        onHide={handleCloseEditForwarderModal}
        onSave={handleEditCustomer}
        isClicked={isClicked}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row mt-0 mb-3">
            <Col xs={12} lg={6}>
              TRADE NAME
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="trade_name"
                className="nc-modal-custom-input"
                value={addDetails.trade_name}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_name}
                message={"Name is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              BIR NAME
              {/* <span className="required-icon">*</span> */}
              <Form.Control
                type="text"
                name="bir_name"
                className="nc-modal-custom-input"
                value={addDetails.bir_name}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mb-3">
            <Col>
              TRADE ADDRESS
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="trade_address"
                className="nc-modal-custom-input"
                value={addDetails.trade_address}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.trade_address}
                message={"Trade Address is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mb-3">
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              BIR REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                className="nc-modal-custom-input"
                value={addDetails.bir_address}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              PAYEE
              <Form.Control
                type="text"
                name="payee"
                className="nc-modal-custom-input"
                value={addDetails.payee}
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mb-3">
            <Col xs={12} lg={4}>
              TIN
              <Form.Control
                type="text"
                name="tin"
                className="nc-modal-custom-input"
                value={addDetails.tin}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              TERM (days)
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="terms"
                className="nc-modal-custom-input"
                value={addDetails.terms}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.terms}
                message={"Terms is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              PHONE NO.
              <Form.Control
                type="text"
                name="phone_no"
                className="nc-modal-custom-input"
                value={addDetails.phone_no}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mb-3">
            <Col xs={12} lg={6}>
              EMAIL
              <Form.Control
                type="text"
                name="email"
                className="nc-modal-custom-input"
                value={addDetails.email}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={6} className="mt-3 mt-lg-0">
              CONTACT PERSON
              <Form.Control
                type="text"
                name="contact_person"
                className="nc-modal-custom-input"
                value={addDetails.contact_person}
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              CREDIT LIMIT
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="credit_limit"
                className="nc-modal-custom-text hide-spinner numeric-input"
                value={addDetails.credit_limit}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.credit_limit}
                message={"Credit limit is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              VAT Type
              <span className="required-icon">*</span>
              <Row className="mb-3">
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="VAT"
                      name="vat_type"
                      value="VAT"
                      className="pt-2"
                      defaultChecked={addDetails.vat_type === "VAT"}
                      onChange={(e) => handleEditChange(e)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="NVAT"
                      name="vat_type"
                      value="NVAT"
                      className="pt-2"
                      defaultChecked={addDetails.vat_type === "NVAT"}
                      onChange={(e) => handleEditChange(e)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <InputError
                isValid={isError.vat_type}
                message={"VAT Type is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-3 mt-lg-0">
              BIR 2307
              <Row className="mb-3">
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="1%"
                      name="withholding_percentage"
                      value="1"
                      className="pt-2"
                      checked={
                        addDetails.withholding_percentage === "1" &&
                        (addDetails.vat_type !== "nvat" ||
                          addDetails.vat_type !== "NVAT")
                      }
                      onChange={(e) => handleEditChange(e)}
                      disabled={addDetails.vat_type === "NVAT" ? true : false}
                    />
                  </Form.Group>
                </Col>
                <Col xs={4} className="print-table-footer-label">
                  <Form.Group className="" controlId="formBasicCheckbox">
                    <Form.Check
                      type="radio"
                      label="2%"
                      name="withholding_percentage"
                      value="2"
                      className="pt-2"
                      checked={
                        addDetails.withholding_percentage === "2" &&
                        (addDetails.vat_type !== "nvat" ||
                          addDetails.vat_type !== "NVAT")
                      }
                      onChange={(e) => handleEditChange(e)}
                      disabled={addDetails.vat_type === "NVAT" ? true : false}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="mt-4 noPrint mx-3">
            <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
            <Row>
              {prevAttachments &&
                prevAttachments.map((attachment) => (
                  <Col
                    xs={12}
                    sm={6}
                    lg={2}
                    onClick={() => {
                      setPreviewFile(attachment.file_url)
                      setPreview(true)
                      setPreviewType("edit")
                    }}
                    className="cursor-pointer preview-container"
                  >
                    <img src={attachment.file_url} className="img-preview" />
                  </Col>
                ))}
              {!prevAttachments ||
                (prevAttachments.length === 0 && (
                  <Col xs={12} sm={6} lg={2}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewModal}
        onHide={handleCloseViewForwarderModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-forwarder-details">
              CUSTOMER DETAILS
            </span>
            <div className="container-wrapper mt-2">
              <Row className="nc-modal-custom-row-view mb-2">
                <Col xs={6} className="nc-modal-custom-row-details">
                  BIR NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.bir_name}</Col>
                  </Row>
                </Col>
                <Col xs={6} className="nc-modal-custom-row-details">
                  BIR REGISTERED ADDRESS
                  <Row className="nc-modal-custom-row">
                    <Col>{addDetails.bir_address}</Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mb-2">
                <Col xs={6} className="nc-modal-custom-row-details">
                  TRADE NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.trade_name}</Col>
                  </Row>
                </Col>
                <Col xs={6} className="nc-modal-custom-row-details">
                  TRADE ADDRESS
                  <Row className="nc-modal-custom-row">
                    <Col>{addDetails.trade_address}</Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="container-wrapper mt-3">
              <Row className="nc-modal-custom-row-view mb-3">
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  TIN
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.tin}</Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  TERM (DAYS)
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.terms}</Col>
                  </Row>
                </Col>
                <Col
                  xs={6}
                  lg={4}
                  className="nc-modal-custom-row-details mt-3 mt-lg-0"
                >
                  CREDIT LIMIT
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {addDetails.credit_limit
                        ? numberFormat(addDetails.credit_limit)
                        : ""}
                    </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details mt-3">
                  EMAIL
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.email}</Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details mt-3">
                  PHONE NO.
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.phone_no}</Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details mt-3">
                  CONTACT PERSON
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.contact_person}</Col>
                  </Row>
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mb-2">
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  VAT TYPE
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.vat_type}</Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  BIR 2307
                  <Row className="nc-modal-custom-row">
                    <Col>
                      {" "}
                      {addDetails.withholding_percentage
                        ? addDetails.withholding_percentage + "%"
                        : ""}{" "}
                    </Col>
                  </Row>
                </Col>
                <Col xs={6} lg={4} className="nc-modal-custom-row-details">
                  PAYEE
                  <Row className="nc-modal-custom-row">
                    <Col> {addDetails.payee} </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div className="mt-4 noPrint">
              <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
              <Row>
                {addDetails &&
                  addDetails?.attachments?.map((attachment) => (
                    <Col
                      xs={12}
                      sm={6}
                      lg={2}
                      onClick={() => {
                        setPreviewFile(attachment.file_url)
                        setPreview(true)
                        setPreviewType("view")
                      }}
                      className="cursor-pointer preview-container"
                    >
                      <img src={attachment.file_url} className="img-preview" />
                    </Col>
                  ))}
                {/* {!fileList ||
                                (fileList.length === 0 && ( */}
                {!fileList && (
                  <Col xs={12} sm={6} lg={2}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>

      <Footer />
      <Modal
        zIndex={1100}
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="attachment"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          {previewType === "edit" && (
            <div className="mt-2 d-flex justify-content-center">
              <img
                src={trash}
                alt="trash"
                onClick={() => handleRemoveItemAttachment(previewFile)}
                className="cursor-pointer"
              />
            </div>
          )}
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
    </div>
  )
}
